import React, { useState, forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'react-bootstrap';

const CreateVehicleRepairRecord = forwardRef((props, ref) => {
    const [formData, setFormData] = useState({
        RepairOrderID: props.data.RepairOrderID,
        VehicleID: props.data.VehicleID,
        CustomerID: props.data.CustomerID,
        RepairDate: props.data.RepairDate,
        // RepairStatus: '',
        // TechnicianID: '',
        // LaborHours: '',
        // ServiceCost: '',
        // Notes: '',
        // PartQuantities: '',
         PartCost: '',
    });
    console.log('formData', formData)
    const [inviteModal, setInviteModal] = useState(false);
    useImperativeHandle(ref, () => ({
        showInviteModal() {
            setInviteModal(true);
        }
    }));
    const [partClasses, setPartClasses] = useState([]);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        const fetchPartClasses = async () => {
            try {
                const response = await axios.get('https://subk.education.com.ly/back/api/getPartClacess'); // Adjust your API URL
                setPartClasses(response.data);
            } catch (error) {
                console.error('Error fetching part classes:', error);
            }
        };
        fetchPartClasses();
    }, []);
    const [expandedPartClassId, setExpandedPartClassId] = useState(null); // Track which part class is expanded
    // Fetch parts when a part class is selected


    // Handle part class selection
    const handlePartClassChange = async (partClass) => {
        const partClassId = partClass.PartClassID;

        // Toggle part class expansion
        if (expandedPartClassId === partClassId) {
            setExpandedPartClassId(null);
            setParts([]); // Clear parts if part class is collapsed
            //setSelectedParts([]); // Reset selected parts when collapsing
        } else {
            setExpandedPartClassId(partClassId);
            try {
                const response = await axios.get(`https://subk.education.com.ly/back/api/partclasses/${partClass.PartClassID}`); // Adjust your API URL
                setParts(response.data);
                console.log('response.data', response.data);
            } catch (error) {
                console.error('Error fetching parts:', error);
            }
        }
    };

    // Handle part selection (checkboxes)

    // Initial state for selected parts with quantity

    // Handle part selection
    const handlePartSelect = (part) => {
        const partExists = selectedParts.some(selected => selected.PartID === part.PartID);

        if (partExists) {
            // If part is already selected, remove it from selectedParts
            setSelectedParts(selectedParts.filter(selected => selected.PartID !== part.PartID));
        } else {
            // Add the part with a default quantity of 1
            setSelectedParts([...selectedParts, { ...part, quantity: 1 }]);
        }
    };

    // Handle quantity change for a part
    const handleQuantityChange = (partID, quantity) => {
        setSelectedParts(
            selectedParts.map(selected =>
                selected.PartID === partID ? { ...selected, quantity: parseInt(quantity) } : selected
            )
        );
    };

    // Get the quantity of a selected part
    const getPartQuantity = (partID) => {
        const selectedPart = selectedParts.find(selected => selected.PartID === partID);
        return selectedPart ? selectedPart.quantity : 1; // Default quantity is 1
    };

    const [parts, setParts] = useState([]);

    const [selectedParts, setSelectedParts] = useState([]);











    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

 
        if (!selectedParts || selectedParts.length === 0) {
            console.error('لم يتم اختيار اي قطع');
        }
      


        // Prepare repair order data
        const repairOrderData = {
            repairDetails: [

                ...selectedParts.map(part => ({
                    RepairOrderID:formData.RepairOrderID,
                    PartID: part.PartID,
                    PartQuantities: part.quantity,
                    PartCost:part.PurchasePrice
                     
                })),

            ]
        };

        // Log the full repairOrderData for debugging purposes
        console.log('Repair Order Data to be Sent:', repairOrderData);

        try {
            // Send the complete data to the API
            const response = await fetch('https://subk.education.com.ly/back/api/repairdetails', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(repairOrderData), // Send the repairOrderData
            });

            const result = await response.json();
            props.fetchRepairOrder();
            setInviteModal(false);
            if (response.ok) {
                toast.success('تم الاضافة بنجاح!');
                props.fetchRepairOrder();
                setSelectedParts([])
                 setInviteModal(false);
            } else {
                console.error('Error saving repair order:', result.message);
                                toast.warning( result.message);

            }
        } catch (error) {
             toast.warning( error);
        }
    };



    const [selectedCategory, setSelectedCategory] = useState(null);



    const [expandedCategoryId, setExpandedCategoryId] = useState(null); // Track which category is expanded



    return (
        <>         <ToastContainer />

        <Modal show={inviteModal} style={{ width: '750px', marginLeft: "200px" }} size="xl" centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">اضافة قطع غيار</h1>
                    <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>setInviteModal(false)}></button>
                    </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {errors && <div className="alert alert-danger">{errors}</div>}

                        <div className="row">
                            <div className="col-xl-6" >

                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <h1>تصنيفات القطع</h1>
                                         {/* Display part classes */}
                                        {partClasses.map(partClass => (
                                            <div key={partClass.PartClassID}>
                                                <div
                                                    onClick={() => handlePartClassChange(partClass)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        margin: '10px 0',
                                                        padding: '10px',
                                                        border: '1px solid #ccc',
                                                       // background: expandedPartClassId === partClass.PartClassID ? 'rgb(37, 50, 78);' :' rgb(24, 34, 55)' // Highlight if expanded
                                                    }}
                                                >
                                                    {partClass.PartClassName}
                                                </div>

                                                {/* Render parts only if the part class is expanded */}
                                                {expandedPartClassId === partClass.PartClassID && parts.length > 0 && (
                                                    <div style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '10px',backgroundColor:' #1c4c49' }}>
                                                        {parts.map(part => (
                                                            <div
                                                                key={part.PartID}
                                                                className="part-details"
                                                                style={{
                                                                    margin: '5px 0',
                                                                    padding: '5px',
                                                                    background: selectedParts.some(selected => selected.PartID === part.PartID) ? '#d1e7dd' : '#fff', // Highlight selected service

                                                                    border: '1px solid #ccc',
                                                                }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedParts.some(selected => selected.PartID === part.PartID)}
                                                                    onChange={() => handlePartSelect(part)}
                                                                />
                                                                <strong style={{ marginLeft: '5px' }}>{part.PartName}</strong>

                                                                {/* Quantity Input for each part */}
                                                                {selectedParts.some(selected => selected.PartID === part.PartID) && (
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={getPartQuantity(part.PartID)} // getPartQuantity will return the current quantity for the part
                                                                        onChange={(e) => handleQuantityChange(part.PartID, e.target.value)}
                                                                        min="1"
                                                                        style={{ width: '100px', marginLeft: '10px', display: 'inline-block' }}
                                                                    />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))}

  
                                    {/* Display selected parts and their quantities */}

                                </div>

                            </div>
                            <div className="col-xl-6">
                                {selectedParts.length > 0 && (
                                    <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc' }}>
                                        <h4>القطع المختارة</h4>
                                        {selectedParts.map(part => (
                                            <div key={part.PartID}>
                                                <strong>{part.PartName}</strong> - الكمية: {part.quantity}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* No parts available message */}
                                {expandedPartClassId && parts.length === 0 && (
                                    <p>هدا التصنيف لا يحتوي علي قطع غيار</p>
                                )}
                            </div>

                        </div>

                    </div>

                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">حفظ التعديلات</button>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </Modal></>
    );
});

export default CreateVehicleRepairRecord;
